import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=64a82198&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=64a82198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a82198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a82198')) {
      api.createRecord('64a82198', component.options)
    } else {
      api.reload('64a82198', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=64a82198&scoped=true&", function () {
      api.rerender('64a82198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QECLCaU8AzT6/JS/comp/SearchFilterTokens.vue"
export default component.exports